import React, { useEffect, useState } from 'react'
import { GetServiceCaller } from '../../../services/serviceCaller';
import { API_URL } from '../../../constants';
import Dynamic_PR_table from '../../../components/Dynamic_PR_table';
import { useDispatch } from 'react-redux';
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';
import { useNavigate } from 'react-router-dom';

const ProjectEvalFeedbacklist = () => {


    const dispatch = useDispatch();
    const navigate = useNavigate()
    useEffect(() => {
        fetchGEt();
        dispatch(updateNavbarHeading("Employee Feedback Report"))
    }, [])
    const [lisitingData, setListingData] = useState([])
    const [searchTerm, setSearchTerm] = useState("")

    const columns = {
        EmployeeName: { text: "Employee", align: "start", visible: true },
        ManagerName: { text: "Manager", align: "start", visible: true },
        OverallRating: { text: "Overall Rating", align: "start", width:"40px",visible: true },
        ReviewDate: { text: "Review Date", align: "center",width:"70px", visible: true },
    }
    const [apiStatus, setApiStatus] = useState(undefined)

    const fetchGEt = async () => {
        setApiStatus(undefined)
        try {

            let response;
            response = await GetServiceCaller(`${API_URL}feedback-details-listing`)
            setApiStatus(response?.status)
            if (response?.status == 200) {
                const cleanedData = response?.data?.data?.feedbacklisting
                setListingData(cleanedData)

            }
        } catch (error) {
            console.error("Fetching Get API Error", error);

        }
    }

    const handleEdit = (id) => {


        navigate(`/employee/feedback/view/${id.EmployeeID}`)
    }
    return (
        <div className="container-fluid" id="skill_section">
            <div className="container-fluid" id="skill-table-area">
                <div className="row">
                    <Dynamic_PR_table
                        data={lisitingData}
                        columns={columns}
                        itemsPerPage={10}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        showIcon1={true}
                        showIcon2={false}
                        isApiStatus={apiStatus}
                        isRequiredStatus={true}
                        isActionRequired={true}
                        isAddNewBtnRequired={false}
                        showIcon3={false}
                        isSorting={true}
                        showIcon4={true}
                        showIcon5={false}
                        handleIcon1={handleEdit}
                        // handleAddNew={handleAddNewClient}
                        // handleIcon4={handleAddSubContractor}
                        add
                        more
                        function
                        icons={{
                            Icon1: <i class="bi bi-eye-fill icons"></i>,
                            Icon1Text: " view",
                            //   Icon2: <i class="bi bi-trash-fill icons"></i>,
                            //   Icon3: <i class="bi bi-eye-fill icons"></i>,
                            //   Icon4: <i class="bi bi-plus-square icons"></i>,
                            //   Icon4Text: " Add Sub-contractor",
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default ProjectEvalFeedbacklist